import React, { useState } from "react";
import bnbcry from "../../asset/bnbcry.png";
import { auth, db } from "../../firebase/Firebase"; // Import your firebase.js file
import "./signuppage.css";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom"; // Import useNavigate for navigation

const SignUpPage = () => {
  const [name, setName] = useState(""); // For user display name
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate(); // Initialize the navigate function

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // Step 1: Create user with Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );
      const user = userCredential.user;

      // Step 2: Set the displayName in Firebase Authentication
      await updateProfile(user, {
        displayName: name, // Set the display name to the entered name
      });

      // Step 3: Save user details (including name) in Firestore
      await setDoc(doc(db, "users", user.uid), {
        name: name,
        email: email,
        balance: 0, // You can set an initial balance or leave it out
      });

      console.log("User registered successfully!");

      // Navigate to "dashboardUser" after successful registration
      navigate("/dashboardUser");
    } catch (err) {
      console.error("Error during registration:", err.message);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signUpPage">
      <img src={bnbcry} alt="" />
      <h3>Investment process starts here</h3>
      <p>Just a few steps away</p>
      <form onSubmit={handleRegister} className="signUpForm">
        <div>
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="email">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div>
          <label htmlFor="password">Password:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? "Registering..." : "Register"}
        </button>
      </form>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </div>
  );
};

export default SignUpPage;
